import { motion } from "framer-motion";

// Staggered fade-up reveal used across sections.
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Eyebrow label used above section headings.
export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-block text-sm md:text-base font-semibold tracking-[0.2em] uppercase text-coral ${className}`}
  >
    {children}
  </span>
);
